import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { browserSentryOptions } from '@frontendlib/common/features/sentry/browser-sentry-options';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Null on any host that is not one of our deployments (local and agent builds): Sentry does not start there at all.
const sentryOptions = browserSentryOptions(environment.sentry, window.location.hostname, {
  recoversChunkLoadErrors: true,
});
if (sentryOptions) {
  try {
    Sentry.init({
      ...sentryOptions,
      // Uncomment to enable performance tracing (tracks page loads, navigation, HTTP requests).
      // tracesSampleRate controls the percentage of transactions sent (1.0 = 100%, 0.2 = 20%).
      // integrations: [Sentry.browserTracingIntegration()],
      // tracesSampleRate: 1.0,
    });
  } catch (e) {
    console.error('Error initializing Sentry browser client', e);
  }
}

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], });

bootstrap();
